import { FC } from 'react';

import { AppModalProps } from '@/types/modal.type';
import { ModalView } from '@/Components/ModalView';
import { CloseSvg } from '@/Components/Icons/CloseSvg';
import { Button } from '@/Components/Button';
import { FlickAnimation } from '@/Components/FlickAnimation';
import { FruitLemonSvg } from '@/Components/Icons/FruitLemonSvg';

export type PausedFlowsModalProps = AppModalProps<{}>;

export const PausedFlowsModal: FC<PausedFlowsModalProps> = ({
    onClose,
}) => {
    return (
        <ModalView
            maxWidth="sm"
            onClose={onClose}
            contentContainerClassName="py-4 text-brand-ocean flex flex-col justify-center items-center">
            <div className="flex flex-row items-center w-full px-6">
                <div className="flex-1 text-heading-four !font-bold text-brand-ocean text-left">
                    Your Flows have been paused
                </div>
                <button
                    title="Close"
                    aria-label="Close"
                    className="p-2 -mr-1 transition-all rounded-md hover:cursor-pointer hover:bg-neutral-mid"
                    onClick={onClose}>
                    <CloseSvg className="[&_path]:stroke-1 [&_path]:stroke-brand-ocean" />
                </button>
            </div>
            <div className="mt-2 mb-4 relative flex flex-row items-center justify-center w-full gap-x-2">
                <FlickAnimation className="mr-12 z-10" />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ">
                    <FruitLemonSvg      
                        width={54}
                        height={54}
                        className="ml-10 mt-2"
                    />
                </div>
            </div>
            <div className="flex flex-col mt-2 mx-6">
                <div className="text-body-text-15 text-brand-ocean">
                    You have a busy website at the moment! 
                </div>
                <div className="text-body-text-15 mt-3 text-brand-ocean">
                    As you have reached your Total Video Impression allowance for the month, your Flows have been temporarily paused until your usage resets at the start of the month.  
                </div>
                <div className="mt-6 flex flex-col gap-y-2">
                    <>
                        <Button
                            variant="primary"
                            className="w-full h-9 flex flex-row items-center justify-center gap-x-1"
                            elementType="a"
                            href={route('settings.organization.plan-billing-payments')}>
                            Upgrade to restore Flows now
                        </Button>
                        <Button
                            variant="default"
                            className="w-full h-9 flex flex-row items-center justify-center gap-x-1 relative"
                            elementType="a"
                            href={route('settings.organization.usage')}   
                        > Review your usage
                        </Button>
                    </>
                </div>
            </div>
        </ModalView>
    );
};
